import { UpdatingElement } from 'lit-element';
import autoRun from '../../decorators/autoRun';

export default class KiListItem extends UpdatingElement {
  static get properties() {
    return {
      selected: { type: Boolean },
      _indent: { type: String },
    };
  }

  constructor() {
    super();
    this.addEventListener('keydown', e => {
      switch (e.key) {
        case 'Enter':
          this.dispatchEvent(new CustomEvent('click'));
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          this._getPrev().focus();
          break;
        case 'ArrowDown':
        case 'ArrowRight':
          this._getNext().focus();
          break;
        default:
      }
    });
  }

  get itemNode() {
    return this;
  }

  _getNext() {
    let next = this.nextSibling;
    while (!/^KI-LIST-ITEM/.test(next.tagName)) {
      next = next.nextSibling;
    }
    return next;
  }

  _getPrev() {
    let next = this.previousSibling;

    while (!/^KI-LIST-ITEM/.test(next.tagName)) {
      next = next.previousSibling;
    }
    return next;
  }

  @autoRun('selected')
  _updateSelectedState() {
    this.setAttribute('tabindex', this.selected ? '0' : '-1');
    this.classList.toggle('selected', !!this.selected);
  }

  connectedCallback() {
    super.connectedCallback();
    let level = 0;
    let node = this;
    while (node && node.tagName !== 'KI-LIST') {
      if (/^KI-LIST/.test(node.tagName)) level += 1;
      node = node.parentElement;
    }
    this.itemNode.style['padding-left'] = `calc( var(--ki-list-indent) * ${level})`;
  }
}

customElements.define('ki-list-item', KiListItem);
